import SearchableCombobox from '../UI/SearchableCombobox';
import { useCountryOptions } from '../../hooks/useCountryOptions';

/**
 * Country/Region of Birth — SearchableCombobox variant="form".
 * Catalogue is API-backed; arbitrary values are rejected by the backend.
 */
const CountryOfBirthField = ({
  value = '',
  onChange,
  theme = 'employee',
  isEditing = true,
  displayValue,
  hasChanged = false,
  error,
  hideLabel = false,
  helpText = 'Where you were born. Independent of nationality.',
}) => {
  const { data: countries = [], isLoading } = useCountryOptions();
  const isAdmin = theme === 'admin';
  const labelClass = isEditing
    ? (isAdmin ? 'field-label' : 'form-label')
    : 'field-label';
  const changedClass = hasChanged
    ? (isAdmin ? 'border-red-300 bg-red-50/30' : 'border-blue-300 bg-blue-50/30')
    : '';

  return (
    <div>
      {!hideLabel && (
        <label className={labelClass}>Country/Region of Birth</label>
      )}
      {isEditing ? (
        <SearchableCombobox
          variant="form"
          theme={theme}
          items={countries}
          value={value || ''}
          onChange={onChange}
          valueFn={(c) => c.id}
          displayFn={(c) => c.name}
          displayValue={value || undefined}
          placeholder="Select country or region"
          searchPlaceholder="Search country or region…"
          clearLabel="Not provided"
          emptyLabel="No matching country"
          loading={isLoading}
          loadingLabel="Loading countries…"
          className={changedClass}
        />
      ) : (
        <p className="field-display">{displayValue || value || 'Not provided'}</p>
      )}
      {error && <p className="form-error">{error}</p>}
      {helpText && <p className="form-help">{helpText}</p>}
    </div>
  );
};

export default CountryOfBirthField;
